import DistributorOnboarding from "@auth/components/onboarding";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Auth } from "creso-core/api";

function RouteComponent() {
  return <DistributorOnboarding defaultStep={1} />;
}

export const Route = createFileRoute("/(auth)/(headless)/welcome")({
  beforeLoad: async ({ location }) => {
    if (location.state?.allowedAccess) return;
    try {
      await Auth.me();
    } catch {
      throw redirect({
        to: "/signup/distributor",
      });
    }
    throw redirect({
      to: "/home",
    });
  },
  component: RouteComponent,
});
